export default __webpack_public_path__ + "static/media/mc_screen_hover.b8830943.svg";